// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_13Kqv","smallLinkTypography":"_32Nc_","titleTypography":"_1-XmJ","cardTitleTypography":"_2PzkR","truncate":"_146R6","modal":"VDlfb","isOpen":"_2I6Yd","content":"FZAau","close":"rrHr_","onBoardingButton":"_17baf","modalIsOpen":"_25ofS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = 1880
// module chunks = 0